import React, { useState } from "react";
import api, { formatApiError } from "../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { toast } from "sonner";

export const OUTCOME_LABELS = {
  no_answer: "No answer", voicemail: "Left voicemail", call_back: "Call back", demo_booked: "Demo booked",
  not_interested: "Not interested", wrong_number: "Wrong number", do_not_call: "Do not call",
};

export const CallOutcomeDialog = ({ callId, open, onDone }) => {
  const [outcome, setOutcome] = useState(null);
  const [notes, setNotes] = useState("");
  const [callbackAt, setCallbackAt] = useState("");
  const [saving, setSaving] = useState(false);

  const save = async () => {
    setSaving(true);
    try {
      const { data } = await api.post(`/calling/calls/${callId}/outcome`, {
        outcome, notes: notes || null, callback_at: outcome === "call_back" && callbackAt ? callbackAt : null,
      });
      toast.success(data.deal_id ? "Outcome logged — pipeline updated" : "Outcome logged");
      setOutcome(null); setNotes(""); setCallbackAt("");
      onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    setSaving(false);
  };

  return (
    <Dialog open={open} onOpenChange={() => {}}>
      <DialogContent className="max-w-md" data-testid="call-outcome-dialog" onInteractOutside={(e) => e.preventDefault()}>
        <DialogHeader><DialogTitle>How did the call go?</DialogTitle></DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          {Object.entries(OUTCOME_LABELS).map(([k, label]) => (
            <button key={k} onClick={() => setOutcome(k)} data-testid={`outcome-${k}`}
              className={`text-sm px-3 py-2.5 rounded-lg border transition-colors ${outcome === k ? "border-primary bg-primary/15 text-primary" : "border-border/70 hover:bg-secondary/60"}`}>
              {label}
            </button>
          ))}
        </div>
        {outcome === "call_back" && (
          <Input type="datetime-local" value={callbackAt} onChange={(e) => setCallbackAt(e.target.value)} data-testid="outcome-callback-at" />
        )}
        <Textarea value={notes} onChange={(e) => setNotes(e.target.value)} placeholder="Notes (optional)" data-testid="outcome-notes" />
        <Button onClick={save} disabled={!outcome || saving} data-testid="outcome-save-button">Save outcome</Button>
      </DialogContent>
    </Dialog>
  );
};
